import { useContext, useState } from 'react';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { UseMutateFunction, useQueryClient } from 'react-query';
import { useAssignRoleToGroup } from './useAssignRoleToGroup';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';

type UseAssignRoleToGroupModalFacade = (groupId: string) => {
  isAssigningRole: boolean,
  assignRole:  UseMutateFunction<AxiosResponse<void>, ErrorResponse, {groupId: string, roleId: string, bindings: string[], isCustom: boolean}>,
  openAssignRoleToGroupModal: () => void,
  closeAssignRoleToGroupModal: () => void,
  isAssignRoleToGroupModalOpen: boolean,
};

export const useAssignRoleToGroupModalFacade: UseAssignRoleToGroupModalFacade = (groupId) => {
  const { showNotification } = useContext(NotificationsContext);
  const queryClient = useQueryClient();
  const [isAssignRoleToGroupModalOpen, setIsAssignRoleToGroupModalOpen] = useState(false);

  const openAssignRoleToGroupModal = () => setIsAssignRoleToGroupModalOpen(true);

  const closeAssignRoleToGroupModal = () => setIsAssignRoleToGroupModalOpen(false);

  const onSuccess = () => {
    queryClient.invalidateQueries(`group-${groupId}-roles`).then();
    showNotification('Role successfully added');
    closeAssignRoleToGroupModal();
  };

  const onError = () => showNotification('An error occurred while assigning role');

  const {
    assignRole,
    isAssigning: isAssigningRole,
  } = useAssignRoleToGroup({
    onSuccess,
    onError,
  });

  return {
    isAssigningRole,
    assignRole,
    openAssignRoleToGroupModal,
    closeAssignRoleToGroupModal,
    isAssignRoleToGroupModalOpen,
  };
};
